export default "__VITE_ASSET__b972076c__"